import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import PracticeCard from "./PraticeCard";
import SearchBar from "../quizz/SeachBar";
import CategoryFilter from "../quizz/CategoryFilter";
import {
  TECHNOLOGY_API_ROUTE,
  EXERCICE_API_ROUTE,
  NIVEAU_API_ROUTE
} from "../../routes/api/api_routes";

const PratiqueBrowser = ({ onPracticeSelect }) => {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [practiceData, setPracticeData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const token = localStorage.getItem("access");

  useEffect(() => {
    const fetchPracticeData = async () => {
      try {
        const [techRes, exoRes, niveauRes] = await Promise.all([
          fetch(TECHNOLOGY_API_ROUTE, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          fetch(EXERCICE_API_ROUTE, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          fetch(NIVEAU_API_ROUTE, {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);

        const techData = await techRes.json();
        const exoData = await exoRes.json();
        const niveauData = await niveauRes.json();

        const technos = techData.data;
        const exercices = exoData.data;
        const niveaux = niveauData.data;

        // Regrouper les exercices par techno
        const grouped = technos.map((tech) => {
          const techExercices = exercices.filter(
            (exo) => exo.technology === tech.id
          );

          const uniqueNiveauIds = [
            ...new Set(techExercices.map((exo) => exo.niveau)),
          ];

          const levels = uniqueNiveauIds.map((nivId) => {
            const niveau = niveaux.find((n) => n.id === nivId);
            return {
              id: niveau.id,
              label: niveau.name,
              stars:
                niveau.name.toLowerCase() === "débutant"
                  ? 1
                  : niveau.name.toLowerCase() === "intermédiaire"
                  ? 2
                  : 3,
              color:
                niveau.name.toLowerCase() === "débutant"
                  ? "bg-yellow-400"
                  : niveau.name.toLowerCase() === "intermédiaire"
                  ? "bg-blue-400"
                  : "bg-green-400",
            };
          });

          return {
            id: tech.id,
            name: tech.name,
            levels,
          };
        });

        setPracticeData(grouped);
      } catch (err) {
        console.error("Erreur lors du chargement des données pratiques", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPracticeData();
  }, [token]);

  const categories = practiceData.map((lang) => ({
    id: lang.id,
    nom: lang.name,
  }));

  const filteredLanguages = practiceData.filter((lang) => {
    const matchCategory =
      selectedCategory === "all" || lang.id === selectedCategory;
    const matchSearch = lang.name
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    return matchCategory && matchSearch;
  });

  if (isLoading) {
    return (
      // <div className="px-1 md:px-5 py-8 mx-auto w-full relative">
      <div className="px-2 sm:px-4 md:px-5 py-8 mx-auto w-full">
        <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-center mb-2">
          Parcourez les langages disponibles
        </h1>
        <p className="text-gray-600 text-center mb-6 max-w-2xl mx-auto">
          Sélectionnez un langage pour commencer à pratiquer selon votre niveau.
        </p>

        <SearchBar onSearch={setSearchTerm} />
        <h2 className="text-xl font-semibold text-center my-4">
          Filtrer par Technologies
        </h2>
        <div className="flex flex-wrap gap-4 mt-4 justify-center max-w-5xl mx-auto my-4">
          {[1, 2, 3, 4].map((i) => (
            <div
              key={i}
              className="bg-gray-200 px-4 py-2 rounded-full border"
            ></div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="bg-gray-200 rounded-2xl h-40 w-full"></div>
          ))}
        </div>
      </div>
    );
  }

  return (
    // <div className="px-5 py-8 mx-auto w-full">
      <div className="px-2 sm:px-4 md:px-5 py-8 mx-auto w-full">
      <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-center mb-2">
        Parcourez les langages disponibles
      </h1>
      <p className="text-gray-600 text-center mb-6 max-w-2xl mx-auto">
        Sélectionnez un langage pour commencer à pratiquer selon votre niveau.
      </p>

      {/* 🔹 Barre de recherche sur desktop */}
      <div className="hidden sm:block">
        <SearchBar onSearch={setSearchTerm} />
      </div>

      <h2 className="text-xl font-semibold text-center my-4">
        Filtrer par Technologies
      </h2>

      <CategoryFilter
        categories={categories}
        selected={selectedCategory}
        onSelect={setSelectedCategory}
      />

      {/* 🔹 Barre de recherche sur mobile (sous les catégories) */}
      <div className="block sm:hidden mt-4">
        <SearchBar onSearch={setSearchTerm} />
      </div>

      <div className="mt-10 grid grid-cols-2 gap-2 md:gap-6 place-items-center items-stretch">
      {/* <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-6 justify-items-center"> */}
        <AnimatePresence>
          {filteredLanguages.map((language, index) => (
            <motion.div
              key={language.id}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 30 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              className="w-full"
            >
              <PracticeCard
                practice={{
                  id: language.id,
                  name: language.name,
                  description: `Commencez à pratiquer ${language.name} selon votre niveau.`,
                }}
                onSelect={() => onPracticeSelect(language.id)}
              />
            </motion.div>
          ))}
        </AnimatePresence>

        {filteredLanguages.length === 0 && (
          <p className="text-center text-gray-500 col-span-full">
            Aucun langage trouvé.
          </p>
        )}
      </div>
    </div>
  );
};

export default PratiqueBrowser;
